(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jill-section3-simplify"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const labels={
    'pinata-custom-theme-13-inches-round-96685':'13 inch',
    'pinata-custom-theme-all-ages-18-71638':'18 inch',
    'pinata-custom-theme-includes-stick-76338':'36 inch',
    'party-favors-surprise-box-custom-05087':'Surprise Box',
    'party-favors-snack-bags-custom-theme-99329':'Snack Bags',
    'party-favors-coloring-box-activity-60610':'Activity Kit',
    'party-favors-coloring-books-custom-08343':'Coloring Books',
    'cake-toppers-1x-large-12x-small-91117':'Cake Topper Set',
    'custom-dtf-t-shirts-for-your-crew-67138':'T-Shirt',
    'custom-dtf-hoodie-for-your-crew-21083':'Hoodie',
    'custom-dtf-crewneck-fleece-for-your-crew-48791':'Crewneck',
    'custom-coffee-mug-photo-sublimation-74734':'Mug',
    'tote-bag-vinyl-transfer-custom':'Tote Bag'
  };
  const hiddenProducts=new Set(['pinata-with-stick-custom-theme-all-87524']);
  const fallback=(t,collection='')=>{
    let s=(t||'')
      .replace(/^(Custom|Personalized)\s+/i,'')
      .replace(/\s+[–—-]\s+\d+\s+Count\b/gi,'')
      .replace(/\s+[–—-]\s+Made to Order\b/gi,'')
      .replace(/\s+[–—-]\s+Personalized Party Favors\b/gi,'')
      .replace(/\s{2,}/g,' ')
      .trim();
    if(collection==='catalog')s=s.replace(/^Party Favors?\s+/i,'');
    if(collection==='kid-activities')s=s.replace(/^Kid (?:Activity|Activities)\s+/i,'');
    if(collection==='party-supplies')s=s.replace(/^Party Suppl(?:y|ies)\s+/i,'');
    if(collection==='pinatas')s=s.replace(/^Piñatas?\s+/i,'').replace(/^Pinatas?\s+/i,'');
    if(collection==='apparel-gifts-dtf-sublimation')s=s.replace(/^Apparel (?:&|and) Gifts?\s+/i,'');
    return s.replace(/\s{2,}/g,' ').trim();
  };

  function init(){
    document.querySelectorAll('.jill-form[data-mode="custom_order"]').forEach(r=>{
      const productsStage=r.querySelector('[data-products-stage]');
      if(!productsStage)return;

      const stepCopy=productsStage.querySelector('.jill-form__step p');
      if(stepCopy)stepCopy.textContent='Choose each item and set the quantity.';

      r.querySelectorAll('[data-collection-products] .jill-collection-extra').forEach(x=>x.remove());

      const apparelCollection=r.querySelector('[data-collection-handle="apparel-gifts-dtf-sublimation"]');
      if(apparelCollection){
        apparelCollection.value='Apparel & Gifts';
        const span=apparelCollection.nextElementSibling;
        if(span)span.textContent='Apparel & Gifts';
      }
      r.querySelectorAll('[data-collection-products="apparel-gifts-dtf-sublimation"]>h3').forEach(h=>h.textContent='Apparel & Gifts');

      r.querySelectorAll('[data-product-card]').forEach(card=>{
        const pick=card.querySelector('[data-product]');
        if(!pick)return;
        const handle=pick.dataset.productHandle||'';
        if(hiddenProducts.has(handle)){
          pick.checked=false;
          card.remove();
          return;
        }

        const shortLabel=labels[handle]||fallback(pick.dataset.productTitle,pick.dataset.productCollectionHandle||'');
        pick.dataset.productTitle=shortLabel;
        pick.value=shortLabel;
        const visible=card.querySelector('.jill-product-choice__pick>span');
        if(visible)visible.textContent=shortLabel;

        const config=card.querySelector('[data-product-config]');
        if(!config)return;

        const variant=config.querySelector('[data-item-variant]');
        if(variant){
          const host=variant.parentElement;
          if(host)host.remove();else variant.remove();
        }

        const notes=config.querySelector('[data-item-notes]');
        if(notes){
          const label=notes.previousElementSibling;
          if(label&&label.tagName==='LABEL')label.remove();
          notes.remove();
        }

        const qty=config.querySelector('[data-item-quantity]');
        if(qty){
          qty.required=!!pick.checked;
          const qtyHost=qty.closest('.jill-qty-stepper')?.parentElement||qty.parentElement;
          const qtyLabel=qtyHost?.querySelector('label');
          if(qtyLabel)qtyLabel.innerHTML='<i>*</i>Quantity';
        }
      });

      const cleanCollectionName=p=>p.dataset.productCollectionHandle==='apparel-gifts-dtf-sublimation'?'Apparel & Gifts':p.dataset.productCollection;
      const writeSummary=()=>{
        const summary=r.querySelector('[data-product-summary]');
        if(summary){
          summary.value=[...r.querySelectorAll('[data-product]:checked')].map(p=>{
            const qty=p.closest('[data-product-card]')?.querySelector('[data-item-quantity]')?.value||'1';
            return `${cleanCollectionName(p)} — ${p.dataset.productTitle} — Qty ${qty}`;
          }).join('\n');
        }
        const csum=r.querySelector('[data-collection-summary]');
        if(csum)csum.value=[...r.querySelectorAll('[data-collection]:checked')].map(c=>c.dataset.collectionHandle==='apparel-gifts-dtf-sublimation'?'Apparel & Gifts':c.value).join(', ');
      };

      const layoutSection4=()=>{
        const design=r.querySelector('[data-stage="design"]');
        if(!design)return false;

        const copy=design.querySelector('.jill-form__step p');
        if(copy)copy.textContent='Tell us the theme, personalization, and any image references.';

        const sameDesign=design.querySelector('[data-multiple-only]');
        if(sameDesign)sameDesign.remove();

        const pers=r.querySelector('[data-pers-system]');
        if(!pers)return false;

        if(pers.parentElement!==design){
          pers.classList.remove('jill-form__card');
          pers.classList.add('jill-pers-inline');

          const oldHead=pers.querySelector('.jill-form__step');
          if(oldHead){
            const title=oldHead.querySelector('h2')?.textContent||'Personalization by item';
            const text=oldHead.querySelector('p')?.textContent||'Set one personalization for everything or split it by selected item.';
            const head=document.createElement('div');
            head.className='jill-pers-inline__head';
            const h3=document.createElement('h3');
            const p=document.createElement('p');
            h3.textContent=title;
            p.textContent=text;
            head.append(h3,p);
            oldHead.replaceWith(head);
          }

          const refFieldset=[...design.querySelectorAll('fieldset.jill-choices')].find(f=>f.querySelector('[data-reference]'));
          if(refFieldset)design.insertBefore(pers,refFieldset);
          else design.append(pers);
        }

        const eventStep=r.querySelector('[data-stage="event"] .jill-form__step>b');
        const finalStep=r.querySelector('[data-stage="final"] .jill-form__step>b');
        if(eventStep)eventStep.textContent='5';
        if(finalStep)finalStep.textContent='6';
        return true;
      };

      r.addEventListener('change',e=>{
        if(e.target.matches('[data-product],[data-item-quantity],[data-collection]'))setTimeout(writeSummary,0);
      });
      r.addEventListener('input',e=>{
        if(e.target.matches('[data-item-quantity]'))setTimeout(writeSummary,0);
      });
      writeSummary();

      let tries=0;
      const settle=()=>{
        layoutSection4();
        if(++tries<24)setTimeout(settle,50);
      };
      settle();
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setTimeout(init,0));
  else setTimeout(init,0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jill-smart-form"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const qa=(r,s)=>Array.from(r.querySelectorAll(s));
  const enable=(box,on)=>{
    if(!box)return;
    box.hidden=!on;
    qa(box,'input,select,textarea').forEach(el=>{
      const active=on&&!el.closest('[hidden]');
      el.disabled=!active;
      if(el.hasAttribute('data-required-visible'))el.required=active;
    });
  };
  const stage=(r,n,on)=>enable(r.querySelector(`[data-stage="${n}"]`),on);
  const selectedCollections=r=>qa(r,'[data-collection]:checked');
  const selectedProducts=r=>qa(r,'[data-product]:checked');

  const localDate=()=>{
    const now=new Date();
    const offset=now.getTimezoneOffset();
    return new Date(now.getTime()-offset*60000).toISOString().slice(0,10);
  };
  const updateDates=r=>{
    const eventDate=r.querySelector('[data-event-date]');
    const needDate=r.querySelector('[data-need-date]');
    if(!eventDate||!needDate)return;
    const today=localDate();
    eventDate.min=today;
    needDate.min=today;
    needDate.max=eventDate.value||'';
    const invalid=!!(eventDate.value&&needDate.value&&needDate.value>eventDate.value);
    needDate.setCustomValidity(invalid?'The date you need it cannot be after the event date.':'');
  };

  const updatePhoneRequirement=r=>{
    const pref=r.querySelector('[data-preferred-contact]');
    const phone=r.querySelector('[data-phone]');
    const label=r.querySelector('[data-phone-label]');
    if(!pref||!phone||!label)return;
    const required=pref.value==='Phone';
    phone.required=required;
    phone.setAttribute('aria-required',required?'true':'false');
    label.innerHTML=required?'<i>*</i>Phone':'Phone <small>optional</small>';
  };

  const updateItemSummary=r=>{
    const summary=r.querySelector('[data-product-summary]');
    if(!summary)return;
    const lines=selectedProducts(r).map(p=>{
      const card=p.closest('[data-product-card]');
      const qty=card?.querySelector('[data-item-quantity]')?.value||'1';
      return `${p.dataset.productCollection} — ${p.dataset.productTitle} — Qty ${qty}`;
    });
    summary.value=lines.join('\n');
    const collectionSummary=r.querySelector('[data-collection-summary]');
    if(collectionSummary)collectionSummary.value=selectedCollections(r).map(x=>x.value).join(', ');
  };

  const updateBranches=r=>{
    const set=(sel,target,yes)=>{
      const value=r.querySelector(sel+':checked')?.value;
      enable(r.querySelector(target),value===yes);
    };
    const personalization=r.querySelector('[data-personalization]:checked')?.value||'';
    const perItem=personalization==='Yes'&&r.querySelector('[data-order-count]:checked')?.value==='Multiple items'&&selectedProducts(r).length>1;
    enable(r.querySelector('[data-personalization-fields]'),personalization==='Yes'&&!perItem);
    set('[data-reference]','[data-reference-fields]','Yes');
    set('[data-fulfillment]','[data-shipping-fields]','Shipping');
  };

  const requiredFieldsReady=box=>{
    if(!box||box.hidden)return false;
    const fields=qa(box,'[required]').filter(field=>!field.disabled&&!field.closest('[hidden]'));
    return fields.every(field=>{
      if(field.type==='radio')return fields.some(candidate=>candidate.type==='radio'&&candidate.name===field.name&&candidate.checked);
      if(field.type==='checkbox')return field.checked;
      return String(field.value||'').trim()!==''&&field.checkValidity();
    });
  };

  const personalizationReady=r=>{
    const card=r.querySelector('[data-pers-system]');
    if(!card||card.hidden)return true;
    const same=card.querySelector('[data-pers-same]:checked')?.value||'';
    if(!same)return false;
    if(same==='Yes')return !!card.querySelector('[data-pers-shared-name]')?.value.trim();
    const keys=selectedProducts(r).map(product=>product.dataset.productHandle+'|'+(product.dataset.productCollectionHandle||''));
    const assigned=new Set();
    const groups=qa(card,'[data-pers-group]');
    if(!groups.length)return false;
    for(const group of groups){
      const items=qa(group,'[data-pers-item]:checked');
      if(!items.length||!group.querySelector('[data-pers-name]')?.value.trim())return false;
      items.forEach(item=>assigned.add(item.value));
    }
    return keys.every(key=>assigned.has(key));
  };

  const syncCascade=r=>{
    if(r.dataset.mode==='contact')return;
    const about=r.querySelector('[data-stage="about"]');
    const order=r.querySelector('[data-stage="order"]');
    const productsStage=r.querySelector('[data-products-stage]');
    const design=r.querySelector('[data-stage="design"]');
    const eventStage=r.querySelector('[data-stage="event"]');
    const finalStage=r.querySelector('[data-stage="final"]');

    const aboutReady=requiredFieldsReady(about);
    enable(order,aboutReady);

    const orderReady=aboutReady&&requiredFieldsReady(order)&&selectedCollections(r).length>0;
    enable(productsStage,orderReady);
    qa(r,'[data-collection-products]').forEach(box=>{
      const on=orderReady&&selectedCollections(r).some(collection=>collection.dataset.collectionHandle===box.dataset.collectionProducts);
      enable(box,on);
    });
    qa(r,'[data-product-card]').forEach(card=>{
      const pick=card.querySelector('[data-product]');
      enable(card.querySelector('[data-product-config]'),orderReady&&!!pick?.checked);
    });

    const productsReady=orderReady&&selectedProducts(r).length>0&&requiredFieldsReady(productsStage);
    stage(r,'design',productsReady);
    updateBranches(r);

    const designReady=productsReady&&requiredFieldsReady(design)&&personalizationReady(r);
    stage(r,'event',designReady);
    updateBranches(r);
    updateDates(r);

    const eventReady=designReady&&requiredFieldsReady(eventStage);
    stage(r,'final',eventReady);

    const submit=r.querySelector('[data-submit]');
    if(submit)submit.hidden=!(eventReady&&requiredFieldsReady(finalStage));
    updateItemSummary(r);
  };

  let cascadeTimer;
  const scheduleCascade=r=>{
    clearTimeout(cascadeTimer);
    cascadeTimer=setTimeout(()=>syncCascade(r),40);
  };

  const updateProductCards=r=>{
    qa(r,'[data-product-card]').forEach(card=>{
      const pick=card.querySelector('[data-product]');
      enable(card.querySelector('[data-product-config]'),!!pick?.checked);
    });
    const error=r.querySelector('[data-product-error]');
    if(error)error.hidden=selectedProducts(r).length>0;
    updateItemSummary(r);
    updateBranches(r);
  };

  const updateCollections=r=>{
    const mode=r.querySelector('[data-order-count]:checked')?.value||'';
    const picks=selectedCollections(r);

    qa(r,'[data-collection-products]').forEach(box=>{
      const on=picks.some(p=>p.dataset.collectionHandle===box.dataset.collectionProducts);
      enable(box,on);
      if(!on){
        qa(box,'[data-product]').forEach(p=>p.checked=false);
        qa(box,'[data-product-config]').forEach(c=>enable(c,false));
      }
    });
    const help=r.querySelector('[data-collection-help]');
    if(help)help.textContent=mode==='Multiple items'?'Select one or more collections.':'Select one collection.';
    const error=r.querySelector('[data-collection-error]');
    if(error)error.hidden=picks.length>0;
    updateProductCards(r);
  };

  const updateOrderType=r=>{
    const count=r.querySelector('[data-order-count]:checked');
    enable(r.querySelector('[data-collections-stage]'),!!count);
    if(!count)return;
    const collections=qa(r,'[data-collection]');
    collections.forEach(x=>x.disabled=false);
    if(count.value==='One item'){
      const checked=collections.filter(x=>x.checked);
      if(checked.length>1)checked.slice(1).forEach(x=>x.checked=false);
      const products=selectedProducts(r);
      if(products.length>1)products.slice(1).forEach(x=>x.checked=false);
    }
    updateCollections(r);
  };

  const updateContact=r=>{
    const value=r.querySelector('[data-contact-reason]')?.value||'';
    qa(r,'[data-contact-group]').forEach(box=>enable(box,false));
    if(['existing','shipping'].includes(value))enable(r.querySelector('[data-contact-group="order"]'),true);
    if(['product','custom','business','website'].includes(value))enable(r.querySelector(`[data-contact-group="${value}"]`),true);
    enable(r.querySelector('[data-contact-message]'),!!value);
  };

  document.querySelectorAll('[data-jill-form]').forEach(r=>{
    r.addEventListener('change',e=>{
      if(e.target.matches('[data-preferred-contact]'))updatePhoneRequirement(r);

      if(r.dataset.mode==='contact'){
        updateContact(r);
        return;
      }

      if(e.target.matches('[data-order-count]'))updateOrderType(r);

      if(e.target.matches('[data-collection]')){
        if(e.target.checked&&r.querySelector('[data-order-count]:checked')?.value==='One item'){
          qa(r,'[data-collection]').forEach(x=>{if(x!==e.target)x.checked=false});
        }
        updateCollections(r);
      }

      if(e.target.matches('[data-product]')){
        if(e.target.checked&&r.querySelector('[data-order-count]:checked')?.value==='One item'){
          qa(r,'[data-product]').forEach(x=>{if(x!==e.target)x.checked=false});
        }
        updateProductCards(r);
      }

      if(e.target.matches('[data-personalization],[data-reference],[data-fulfillment]'))updateBranches(r);
      if(e.target.matches('[data-item-quantity]'))updateItemSummary(r);
      if(e.target.matches('[data-event-date],[data-need-date]'))updateDates(r);
      scheduleCascade(r);
    });

    r.addEventListener('input',e=>{
      if(e.target.matches('[data-item-quantity]'))updateItemSummary(r);
      if(e.target.matches('[data-event-date],[data-need-date]'))updateDates(r);
      scheduleCascade(r);
    });

    r.addEventListener('submit',e=>{
      updatePhoneRequirement(r);
      updateDates(r);
      if(r.dataset.mode!=='contact'){
        if(selectedCollections(r).length===0){
          e.preventDefault();
          const er=r.querySelector('[data-collection-error]');
          if(er){er.hidden=false;er.scrollIntoView({behavior:'smooth',block:'center'})}
          return;
        }
        if(selectedProducts(r).length===0){
          e.preventDefault();
          const er=r.querySelector('[data-product-error]');
          if(er){er.hidden=false;er.scrollIntoView({behavior:'smooth',block:'center'})}
          return;
        }
        updateItemSummary(r);
      }
    });

    updatePhoneRequirement(r);
    updateDates(r);
    if(r.dataset.mode==='contact')updateContact(r);else{
      updateOrderType(r);
      syncCascade(r);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
